import React from 'react';
import { ChallengesIcon } from './icons/ChallengesIcon';

/**
 * Challenges — not built yet; this page says so (SideNav "Challenges",
 * App.tsx view 'challenges'). Same layout as Ocean's Coming Soon page.
 */
export const ChallengesPage: React.FC = () => (
    <div className="flex-1 flex items-center justify-center p-6 overflow-y-auto">
        <div className="max-w-xl w-full flex flex-col items-center text-center gap-4 py-12">
            <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center text-primary-700">
                <span className="scale-150"><ChallengesIcon active /></span>
            </div>

            <h1 className="text-grayscale-1300 font-grotesk text-3xl font-bold">
                Coming Soon!
            </h1>

            <p className="text-grayscale-1300 font-grotesk text-base">
                Challenges are on their way.
            </p>
            <p className="text-grayscale-1200 font-grotesk text-base">
                We'll let you know as soon as they open.
            </p>
        </div>
    </div>
);

export default ChallengesPage;
